// Formatuje cenę usługi, dopisując "zł" tylko gdy jeszcze go nie ma.
export const formatPriceLabel = (price) => {
  if (price === undefined || price === null || String(price).trim() === '') return 'wycena indywidualna';
  const text = String(price).trim();
  return /zł/i.test(text) ? text : `${text} zł`;
};
